import {fetchWithState, getFetchedJSON, fetchWithMessage} from '~/misc/fetch';


export const getPrice = (getState) => {
  return fetchWithState(getState, {
    method: 'GET',
    url: `/tl/fuel/price`,
  }).then(getFetchedJSON);
};



// WEBPACK FOOTER //
// ./src/pages/FuelSurchargePage/state/api.js